import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative grid grid-cols-1 lg:grid-cols-12" }
const _hoisted_2 = { class: "hidden lg:col-start-1 lg:col-end-4 lg:row-start-1 lg:block" }
const _hoisted_3 = { class: "h-full py-28 pr-10 text-right" }
const _hoisted_4 = {
  key: 0,
  class: "-mx-10 lg:hidden"
}
const _hoisted_5 = { class: "relative pt-1/1" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "font-quote text-9xl" }
const _hoisted_8 = {
  key: 0,
  class: "mb-2 text-sm font-medium uppercase leading-5 tracking-wider lg:text-base"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-4 h-0.5 w-8 bg-current" }, null, -1)
const _hoisted_10 = { class: "text-4xl lg:text-7xl" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "hidden lg:col-start-8 lg:col-end-13 lg:row-start-1 lg:block"
}
const _hoisted_13 = { class: "sticky top-20 w-full pt-2/3" }
const _hoisted_14 = ["innerHTML"]

import { onMounted, ref } from 'vue';
import AnimatedNumber from '@/components/base/AnimatedNumber.vue';

interface Item {
    year: number;
    kicker?: string;
    title: string;
    text: string;
    image?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessSection',
  props: {
    items: { default: () => [] },
    sectionStyle: { default: 'default' },
    imageLayout: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { items: Item[], sectionStyle: 'default' | 'contrast' | 'semi' | 'contrastCampaign', imageLayout: boolean }



const currentItemIndex = ref(0);
const itemRefs = ref<HTMLDivElement[]>([]);

onMounted(() => {
    document.addEventListener('scroll', onScroll);
});

const getImageStyles = (index: number) => {
    return {
        clipPath: `inset(0% 0% ${currentItemIndex.value > index ? 100 : 0}%)`,
        zIndex: props.items.length - index
    };
};

const onScroll = () => {
    calcCurrentItemIndex();
};

const calcCurrentItemIndex = () => {
    const viewPortHeight = window.innerHeight;
    itemRefs.value.forEach((item, index) => {
        const top = item.getBoundingClientRect().top;
        // active if top of element is halfway in the viewport
        const active = top <= viewPortHeight / 2;
        if (active) {
            currentItemIndex.value = index;
        }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AnimatedNumber, {
          number: __props.items[currentItemIndex.value].year,
          duration: 3000,
          class: "sticky top-40 font-quote text-9xl"
        }, null, 8, ["number"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["relative lg:z-10 lg:col-start-4 lg:row-start-1 lg:border-l lg:border-opacity-30 lg:pt-32", [
                __props.sectionStyle === 'contrast' || __props.sectionStyle === 'contrastCampaign'
                    ? 'lg:border-white'
                    : 'lg:border-gray-400',
                __props.imageLayout ? 'lg:col-end-10' : 'lg:col-end-13'
            ]])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute left-0 top-0 z-10 hidden h-10 w-1 -translate-x-1/2 transform bg-gradient-to-b to-transparent lg:block", {
                    'from-black': props.sectionStyle === 'contrastCampaign',
                    'from-gray-500': props.sectionStyle === 'contrast',
                    'from-gray-200': props.sectionStyle === 'semi',
                    'from-white': props.sectionStyle === 'default'
                }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute left-0 bottom-0 z-10 hidden h-10 w-1 -translate-x-1/2 transform bg-gradient-to-t to-transparent lg:block", {
                    'from-black': props.sectionStyle === 'contrastCampaign',
                    'from-gray-500': props.sectionStyle === 'contrast',
                    'from-gray-200': props.sectionStyle === 'semi',
                    'from-white': props.sectionStyle === 'default'
                }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col", __props.imageLayout ? 'gap-32 lg:gap-72' : 'gap-16 lg:gap-44'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["relative flex flex-col gap-5 lg:gap-10 lg:p-10", {
                        'bg-black': props.sectionStyle === 'contrastCampaign',
                        'bg-gray-500': props.sectionStyle === 'contrast',
                        'bg-gray-200': props.sectionStyle === 'semi',
                        'bg-white': props.sectionStyle === 'default'
                    }]),
            ref_for: true,
            ref_key: "itemRefs",
            ref: itemRefs
          }, [
            (__props.imageLayout)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "absolute inset-0",
                      innerHTML: item.image
                    }, null, 8, _hoisted_6)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["relative -mr-8 -mt-37 pr-8 text-right lg:hidden", {
                            'bg-white': props.sectionStyle === 'default',
                            'bg-gray-200': props.sectionStyle === 'semi',
                            'bg-gray-500': props.sectionStyle === 'contrast',
                            'bg-black': props.sectionStyle === 'contrastCampaign'
                        }])
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.year), 1)
            ], 2),
            _createElementVNode("div", null, [
              (item.kicker)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(item.kicker), 1),
                    _hoisted_9
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", _hoisted_10, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["prose prose-md prose-p:mt-0", {
                            'text-white':
                                props.sectionStyle === 'contrast' ||
                                props.sectionStyle === 'contrastCampaign'
                        }]),
              innerHTML: item.text
            }, null, 10, _hoisted_11)
          ], 2))
        }), 128))
      ], 2)
    ], 2),
    (__props.imageLayout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "absolute inset-0 transition-all duration-1000",
                innerHTML: item.image,
                style: _normalizeStyle(getImageStyles(index))
              }, null, 12, _hoisted_14))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})